import './Email.css';
/* src/Email.svelte generated by Svelte v3.23.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	destroy_each,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	text
} from "/web_modules/svelte/internal.js";

import { onMount, onDestroy } from "/web_modules/svelte.js";
import { drawHTML } from "./sandboxhtml.js";
import mod from "/web_modules/mime-to-jmap.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[15] = list[i];
	return child_ctx;
}

// (102:6) {#each message.from as from}
function create_each_block_1(ctx) {
	let span;
	let t0_value = /*from*/ ctx[15].name + "";
	let t0;
	let t1;
	let a;
	let t2_value = /*from*/ ctx[15].email + "";
	let t2;
	let a_href_value;

	return {
		c() {
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			a = element("a");
			t2 = text(t2_value);
			attr(a, "href", a_href_value = "mailto:" + /*from*/ ctx[15].email);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t0);
			insert(target, t1, anchor);
			insert(target, a, anchor);
			append(a, t2);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
			if (detaching) detach(t1);
			if (detaching) detach(a);
		}
	};
}

// (113:8) {:else}
function create_else_block(ctx) {
	let a;
	let t_value = /*att*/ ctx[12].name + "";
	let t;
	let a_href_value;
	let a_download_value;

	return {
		c() {
			a = element("a");
			t = text(t_value);
			attr(a, "href", a_href_value = /*att*/ ctx[12].url);
			attr(a, "download", a_download_value = /*att*/ ctx[12].name);
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (111:8) {#if showTypes.has(att.type)}
function create_if_block_1(ctx) {
	let a;
	let t_value = /*att*/ ctx[12].name + "";
	let t;
	let a_href_value;

	return {
		c() {
			a = element("a");
			t = text(t_value);
			attr(a, "href", a_href_value = /*att*/ ctx[12].url);
			attr(a, "target", "_blank");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (110:6) {#each attachments as att}
function create_each_block(ctx) {
	let show_if;
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (/*showTypes*/ ctx[4].has(/*att*/ ctx[12].type)) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if_block.p(ctx, dirty);
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (124:4) {#if bodyObj.type !== 'text/html'}
function create_if_block(ctx) {
	let pre;

	return {
		c() {
			pre = element("pre");
			pre.textContent = `${/*bodyData*/ ctx[6]}`;
		},
		m(target, anchor) {
			insert(target, pre, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(pre);
		}
	};
}

function create_fragment(ctx) {
	let div5;
	let div3;
	let h2;
	let t1;
	let div0;
	let t2;
	let t3;
	let div1;
	let t6;
	let div2;
	let t7;
	let a;
	let t8;
	let t9;
	let div4;
	let each_value_1 = /*message*/ ctx[2].from;
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = /*attachments*/ ctx[3];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block = /*bodyObj*/ ctx[5].type !== "text/html" && create_if_block(ctx);

	return {
		c() {
			div5 = element("div");
			div3 = element("div");
			h2 = element("h2");
			h2.textContent = `${/*message*/ ctx[2].subject}`;
			t1 = space();
			div0 = element("div");
			t2 = text("From: \n      ");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t3 = space();
			div1 = element("div");
			div1.textContent = `Sent at: ${new Date(/*message*/ ctx[2].sentAt).toLocaleString()}`;
			t6 = space();
			div2 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t7 = space();
			a = element("a");
			t8 = text("View raw message");
			t9 = space();
			div4 = element("div");
			if (if_block) if_block.c();
			attr(h2, "class", "subject");
			attr(a, "href", /*rawMessageURL*/ ctx[1]);
			attr(a, "target", "_blank");
			attr(div3, "class", "info svelte-16mq781");
			attr(div4, "class", "body svelte-16mq781");
			attr(div5, "class", "email svelte-16mq781");
		},
		m(target, anchor) {
			insert(target, div5, anchor);
			append(div5, div3);
			append(div3, h2);
			append(div3, t1);
			append(div3, div0);
			append(div0, t2);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(div0, null);
			}

			append(div3, t3);
			append(div3, div1);
			append(div3, t6);
			append(div3, div2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div2, null);
			}

			append(div3, t7);
			append(div3, a);
			append(a, t8);
			append(div5, t9);
			append(div5, div4);
			if (if_block) if_block.m(div4, null);
			/*div4_binding*/ ctx[11](div4);
		},
		p(ctx, [dirty]) {
			if (dirty & /*message*/ 4) {
				each_value_1 = /*message*/ ctx[2].from;
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(div0, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty & /*attachments, showTypes*/ 24) {
				each_value = /*attachments*/ ctx[3];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div2, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (/*bodyObj*/ ctx[5].type !== "text/html") if_block.p(ctx, dirty);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div5);
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			if (if_block) if_block.d();
			/*div4_binding*/ ctx[11](null);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { raw } = $$props;
	console.log("raw", raw);

	// Marking it as message/rfc822 downloads the file .. is that what we want?
	// let rawMessageBlob = new Blob([raw], {type: 'message/rfc822'})
	let rawMessageBlob = new Blob([raw], { type: "text/plain" });

	let rawMessageURL = URL.createObjectURL(rawMessageBlob);

	// Get message attachments... and maybe the message itself?
	const { json: message, attachments: attachmentData } = mod.envelope_to_jmap(raw, { with_attachments: true });

	console.log("attachments", attachmentData);
	console.log("rendering message", message);
	const attachments = [];
	const urlForCid = {};
	const showTypes = new Set(["image/gif", "image/png", "image/jpeg", "text/plain", "text/html"]);

	for (const { name, blobId, type, cid } of message.attachments) {
		const data = attachmentData[blobId];
		console.log("attachment", name, blobId, type, data.byteLength);
		const url = URL.createObjectURL(new Blob([data], { type }));
		attachments.push({ name: name || blobId, type, url });
		if (cid != null) urlForCid[cid] = url;
	}

	onDestroy(() => {
		URL.revokeObjectURL(rawMessageURL);

		for (const { url } of attachments) {
			// console.log('revoke', url)
			URL.revokeObjectURL(url);
		}
	});

	let bodyContainer;
	let bodyObj = message.htmlBody[0];
	let bodyData = message.bodyValues[bodyObj.partId].value;

	onMount(() => {
		if (bodyObj.type === "text/html") {
			let html = drawHTML(bodyData, urlForCid);

			// console.log('htmlBody', message.htmlBody[0], message.bodyValues[message.htmlBody[0].partId])
			// Wire up inline images
			const images = html.getElementsByTagName("img");

			for (const img of images) {
				const src = img.src;

				if (src.startsWith("cid:")) {
					const cid = src.slice(("cid:").length);
					img.src = urlForCid[cid];
				}
			}

			bodyContainer.appendChild(html);
		}
	});

	function div4_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(0, bodyContainer = $$value);
		});
	}

	$$self.$set = $$props => {
		if ("raw" in $$props) $$invalidate(7, raw = $$props.raw);
	};

	return [
		bodyContainer,
		rawMessageURL,
		message,
		attachments,
		showTypes,
		bodyObj,
		bodyData,
		raw,
		urlForCid,
		rawMessageBlob,
		attachmentData,
		div4_binding
	];
}

class Email extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { raw: 7 });
	}
}

export default Email;